import { apiClient } from '../lib/api-client';

/**
 * UserSession DTO returned by the BFF `/sessions` REST endpoints.
 * Matches the auth service's `UserSessionDto` shape from `@app/contracts`.
 *
 * @see HZVT-149_ADD_AUTH_SESSION_MANAGEMENT
 */
export interface UserSessionDto {
  id: string;
  userId: string;
  orgId: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  /** ISO-8601 timestamp of last authenticated request seen on this session. */
  lastActiveAt: string;
  /** ISO-8601 timestamp at which the session was revoked, or null when active. */
  revokedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * API functions for user session management.
 * Uses the centralized apiClient for automatic token attachment + 401 handling.
 *
 * @see HZVT-149_ADD_AUTH_SESSION_MANAGEMENT
 */
export const sessionsApi = {
  /** List active sessions for the authenticated user, most recently active first. */
  list: () => apiClient.get<UserSessionDto[]>('/sessions'),

  /** Revoke a single session by ID. The server enforces caller ownership. */
  revoke: (sessionId: string) => apiClient.delete<UserSessionDto>(`/sessions/${sessionId}`),

  /**
   * Revoke every session except the current one (the one whose JWT is being
   * used for this request). Returns the count of revoked sessions.
   */
  revokeOthers: () => apiClient.post<{ revokedCount: number }>(`/sessions/revoke-others`),
};
